import * as DomPurify from 'dompurify'

const setBreadcrumbs = (breadcrumbs: { name: string, url?: string }[]) => {
    // remove existing shop breadcrumbs
    $('.breadcrumb .additional-breadcrumb-item').remove()
    $('.breadcrumb-item.active').remove()

    // add new breadcrumbs to the list
    breadcrumbs.forEach((bc, index) => {
        const current = index === breadcrumbs.length - 1
        $('.breadcrumb').append(`
                <li class="breadcrumb-item additional-breadcrumb-item${current ? ' active' : ''}" ${current ? 'aria-current="page"' : ''}>
                    ${current ? DomPurify.sanitize(bc.name) : `<a href="${DomPurify.sanitize(bc.url)}">${DomPurify.sanitize(bc.name)}</a>`}
                </li>
            `)
    })
}

$(function () {
    window.addEventListener('route-changed', (e: CustomEvent) => {
        const breadcrumbs = e.detail.breadcrumbs as [{ name: string, url?: string }]
        setBreadcrumbs(breadcrumbs)
    })

    const dispatchCrumb: JQuery<HTMLInputElement> = $('#article-breadcrumb')
    if (dispatchCrumb.length) {
        setBreadcrumbs([{ name: dispatchCrumb.val() as string }])
    }
})